module.exports = __webpack_public_path__ + "static/media/unselectedDragAndDropHover.2fc9d8e2.png";